import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-020426b3")

_pushScopeId("data-v-020426b3")
const _hoisted_1 = { class: "flex flex-col gap-1" }
const _hoisted_2 = { class: "text-xs font-medium text-black-lp-100" }
const _hoisted_3 = { class: "font-bold text-black-lp-100" }
const _hoisted_4 = {
  key: 0,
  class: "flex flex-col justify-end ml-auto border-l border-gray-lp-400 pl-2"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "text-xs font-medium text-black-lp-100" }, "Selesai", -1)
const _hoisted_6 = { class: "font-bold text-black-lp-100" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Icons = _resolveComponent("Icons")!

  return (_openBlock(), _createBlock("div", {
    class: ["rounded-xl py-2 px-3 flex flex-row items-center gap-2 mt-3 w-full", _ctx.containerLinearClass]
  }, [
    _createVNode("div", {
      class: ["rounded-full h-8 w-8 bg-white flex flex-row items-center justify-center", _ctx.iconColorClass]
    }, [
      _createVNode(_component_Icons, { name: _ctx.icon }, null, 8, ["name"])
    ], 2),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, _toDisplayString(_ctx.label), 1),
      _createVNode("div", _hoisted_3, [
        (_ctx.variant === 'value')
          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(_ctx.value), 1)
            ], 64))
          : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(_ctx.total), 1)
            ], 64))
      ])
    ]),
    (_ctx.variant === 'progress')
      ? (_openBlock(), _createBlock("div", _hoisted_4, [
          _hoisted_5,
          _createVNode("div", _hoisted_6, _toDisplayString(_ctx.completed) + "/" + _toDisplayString(_ctx.total), 1)
        ]))
      : _createCommentVNode("", true)
  ], 2))
})